import React, { FC, useCallback } from "react";
import { IHeaderParams } from "ag-grid-community";

import { useParameter } from "../../../shared";

const AgGridHeaderComponent: FC<IHeaderParams> = ({ displayName, column }) => {
  const [, selectCommodityId] = useParameter<number>("@selected_commodity_id");

  const onClickHandler = useCallback(() => {
    selectCommodityId(Number(column.getColId()));
  }, [column]);

  return (
    <div className="ag-header-group-cell-label ag-header-commodity-link" onClick={onClickHandler}>
      <span className="ag-header-cell-text">{displayName}</span>
    </div>
  );
};

export { AgGridHeaderComponent };
